import React from 'react';
import styles from '../../../styles/ViewListing.module.css';

interface DetailsProps {
    detail: any
}

const PropertyDetails: React.FC<DetailsProps> = ({ detail }) => {
  const initials = detail.agent
    ? `${(detail.agent.fullNames ?? '').charAt(0)}${(detail.agent.lastName ?? '').charAt(0)}`.toUpperCase()
    : '';

  const fields: { label: string; value: string | number | null | undefined }[] = [
    detail.unitNumber   ? { label: 'Unit',        value: detail.unitNumber }   : null,
    detail.complexName  ? { label: 'Complex',     value: detail.complexName }  : null,
    detail.streetNumber ? { label: 'Street No.',  value: detail.streetNumber } : null,
    detail.streetName   ? { label: 'Street',      value: detail.streetName }   : null,
    detail.city         ? { label: 'City',         value: detail.city }         : null,
    detail.province     ? { label: 'Province',     value: detail.province }     : null,
    detail.postalCode   ? { label: 'Postal Code',  value: detail.postalCode }   : null,
  ].filter(Boolean) as { label: string; value: string | number }[];

  return (
    <section className={styles.section}>
      <p className={styles.sectionTitle}>Property Details</p>
      <div className={styles.detailsGrid}>
        {fields.map(f => (
          <div key={f.label} className={styles.detailItem}>
            <span className={styles.detailLabel}>{f.label}</span>
            <span className={styles.detailValue}>{f.value}</span>
          </div>
        ))}
      </div>

      {detail.agent && (
        <div className={styles.agentRow}>
          <div className={styles.agentAvatar}>{initials}</div>
          <div className={styles.agentInfo}>
            <span className={styles.agentName}>
              {detail.agent.fullNames} {detail.agent.lastName}
            </span>
            {detail.agent.email && (
              <span className={styles.agentEmail}>{detail.agent.email}</span>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default PropertyDetails;
